import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"overflow":"auto"}
}
const _hoisted_2 = { class: "fade-in" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "rounded drop-shadow-md hover:drop-shadow-xl bg-gray-100" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl" }, "Patient's Name"),
    /*#__PURE__*/_createElementVNode("p", null, "Patient's Details"),
    /*#__PURE__*/_createElementVNode("p", null, "ID number:"),
    /*#__PURE__*/_createElementVNode("p", null, "Gender:"),
    /*#__PURE__*/_createElementVNode("p", null, "Date of Birth:"),
    /*#__PURE__*/_createElementVNode("p", null, "Blood Type:")
  ])
], -1)
const _hoisted_4 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Adherence to Medication:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "range",
  min: "1",
  max: "100",
  value: "50"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "List", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("textarea", {
  rows: "10",
  class: "border-double border-4 border-indigo-600"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_13 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "Results", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", { class: "border-double border-4 border-indigo-600" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "Results", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("input", { class: "border-double border-4 border-indigo-600" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "Results", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", { class: "border-double border-4 border-indigo-600" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "Results", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("input", { class: "border-double border-4 border-indigo-600" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "List", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("textarea", {
  rows: "10",
  class: "border-double border-4 border-indigo-600"
}, null, -1)
const _hoisted_24 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "List", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("textarea", {
  rows: "10",
  class: "border-double border-4 border-indigo-600"
}, null, -1)
const _hoisted_27 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "List", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("textarea", {
  rows: "10",
  class: "border-double border-4 border-indigo-600"
}, null, -1)
const _hoisted_30 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h1", { class: "font-size-5 font-weight-bold" }, "List", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("textarea", {
  rows: "10",
  class: "border-double border-4 border-indigo-600"
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, [
  /*#__PURE__*/_createElementVNode("p", null, " Patient's History, Clinical Findings, Diagnostic Test Results, Pre and Postoperative care, Patient's Progress and Medication "),
  /*#__PURE__*/_createElementVNode("textarea", {
    rows: "10",
    class: "border-double border-4 border-indigo-600"
  })
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_35 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "Trust Level:"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "range",
    min: "1",
    max: "100",
    value: "50"
  })
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "ion-padding",
  slot: "content"
}, "Content", -1)

import { useCounterStore } from "../store.ts";
import { storeToRefs } from "pinia";


import { IonAccordion, IonAccordionGroup, IonItem, IonLabel } from "@ionic/vue";
import { defineComponent } from "vue";

import { IonCheckbox } from "@ionic/vue";

const __default__ = defineComponent({
  components: {
    IonCheckbox,
    IonAccordion,
    IonAccordionGroup,
    IonItem,
    IonLabel,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AppPage',
  setup(__props) {

const store = useCounterStore();

const { loggedIn } = store;

return (_ctx: any,_cache: any) => {
  return (_unref(loggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonAccordionGroup), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonAccordion), { value: "first" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Patient Details")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "second" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Monitoring Adherence to Medication, Administration of Medication and Other Treatments")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Daily Medication Taken")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Noon Medication Taken")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Evening Medication Taken")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Fluids Administered")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Shots Administered")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Topical Solutions Administered")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Oral Solutions Administered")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Other Solutions And Treatments Administered (Eye Drops, Wound Dressing etc.)")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_7,
                    _hoisted_8
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.44" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("New Symptoms Enquiring")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.45" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Health Conditions Assessment")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.46" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Health Education Provided")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.47" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Advising on Therapies and Lifestyle Choices")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.5" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Medical Tests")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Blood Pressure Taken")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Blood Sample Taken")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Temperature Check")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_18,
                    _hoisted_19,
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Breathing Check")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Other")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_22,
                    _hoisted_23
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.55" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Life Support")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Total Parenteral Nutrition Setup")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Ventilator Tube Change")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Other")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_25,
                    _hoisted_26
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.56" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Wheelchair and other Movement Apparatus")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Placement onto the wheelchair")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Removal from the wheelchair")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Other")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_28,
                    _hoisted_29
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "2.6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("First Aid Performed")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("CPR")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Other")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_31,
                    _hoisted_32
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "third" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Writing and Updating Patient Records")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "fourth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Assessing and Planning Nursing Care Requirements")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "fifth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Organising Workload")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), { slot: "start" }),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("Day has been completed")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "sixth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Relationship Building/Discussions (Reassurance, Listening and Talking to Patients) Records")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_36
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "seventh" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Care Plans and Progress monitoring")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_37
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "eighth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Giving Advice and Arranging Support for Patients, Relatives and Carers")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_38
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "ninth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Liaising with Doctors, Social Workers and Other Professionals")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_39
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "tenth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Assessing Treatment Success at Case Conferences and Meetings")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "eleventh" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Encouraging Patients to take part in Therapeutic Activities such as Art and Role Play")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "twelveth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Combating Stigma and Helping Patients and their Families Manage it")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_42
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "thirteenth" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Living Conditions Assessment")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_43
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "14" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Assessment of Social and Daily Life Richness")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_44
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "16" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Assessment of Quality of Relationships with Others")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_45
                ]),
                _: 1
              }),
              _createVNode(_unref(IonAccordion), { value: "16" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { color: "dark" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Assessment of Independence Level")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_46
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})